<template>
  	<UiModal title="Ședință acum" :subtitle="specialist.full_name" :buttons="buttons"
	  	@close="closeModal"
		@topup="closeModal(), $router.push({ path: '/client/topup' })"
		@leave="closeModal">
		
    	<template v-slot:body>
			
			<div v-if="!hasEnoughBalance" class="">
				<div class="queue__info">
					Credit insuficient! Trebuie să dețineți minim 
					<span class="queue__info--warning">
						{{ specialist.minute_price*10 }} credite
					</span>
					pentru a intră în sesiune.
				</div>
			</div>
			
			<div v-else class="queue">
				<template v-if="currentPage == 0">
					<div class="queue__title">
						Status așteptare
					</div>
					
					<div class="queue__divider"></div>
					
					<div class="queue__details">
						<div class="queue__details-list">
							
							<div class="list-item">
								<div class="list-item__icon">
									<i class="fas fa-users"></i>
								</div>
								<div class="list-item__text">
									Poziția dvs. în coadă:
									
									<div class="list-item__text--primary">
										{{ myPosition }}
									</div> din {{ positionsCount }}
								</div>
							</div>
							
							<div class="list-item">
								<div class="list-item__icon">
									<img src="@/assets/images/icons/coins.svg" alt="Nexyo coins"> 
								</div>
								<div class="list-item__text">
									Cost per minut:
									
									<div class="list-item__text--warning">
										{{ specialist.minute_price }}
									</div>
								</div>
							</div>
							
							<!-- <div class="list-item">
								<div class="list-item__icon">
									<i class="fas fa-clock"></i>
								</div>
								<div class="list-item__text">
									Ultima sesiune a început acum
									
									<div class="list-item__text--primary">
										15 minute
									</div>
								</div>
							</div> -->
						</div>
						
						<div class="queue__description">
							Durata minimă a unei sesiuni este de 10 minute și se va achita automat la 
							intrarea în camera de întâlnire. După efectuarea minimului de 10 minute, 
							taxarea se va face automat din minut în minut până la finalizarea sesiunii.
						</div>
					</div>
					
				</template>
				
				<template v-else>
					<div class="queue__title">
						Anunțuri
					</div>
					
					<div class="queue__divider"></div>
					
					<div class="queue__messages" ref="messages">
						<div class="message" v-for="message in messages" :key="message.id">
							<div class="message__meta">
								<h4 class="message__name">
									{{ specialist.full_name  }}
								</h4>
								<h4 class="message__datetime">
									{{ message.created_at | moment('from') }}
								</h4>
							</div>
							<p class="message__text">
								{{ message.text }}
							</p>
						</div>
					</div>
				</template>
				
				<div class="navigation">
					<div class="navigation__arrow" @click="prevPage">
						<i class="fas fa-arrow-left"></i>
					</div>
					<div class="navigation__bullets">
						<div class="navigation__bullet"
							:class="{'navigation__bullet--active': currentPage == 0}"></div>
						<div class="navigation__bullet"
							:class="{'navigation__bullet--active': currentPage == 1}"></div>
					</div>
					<div class="navigation__arrow" :class="{'navigation__bullet--alert': newMessage}" @click="nextPage">
						<i class="fas fa-arrow-right"></i>
					</div>
				</div>
				<audio style="display: none;" preload="none" id="anytime-new-announcement">
            		<source src="@/assets/audio/queueupdates.mp3" type="audio/mpeg">
          		</audio>
			</div>
    	</template>
  	</UiModal>
</template>

<script>

import UiModal from "@/components/ui/Modal";
import { mapGetters } from 'vuex'
	
export default {
  	components: { UiModal },
	data() {
		return {
			buttons: [
				{ event: "topup", text: "Adaugă credite", style: "gradient" }, //Added by ~RJ | 20.09.21 | Can be removed after offering In-Meeting Topups
				{ event: "leave", text: "Părăsește coada" },
				],	
			currentPage: 0,
			messages: [],
			interval: null,
			timer: 0,
			myPosition: null,
			positionsCount: null,
			queueChannel: null,
			orderNumber: null,
			newMessage: false
		};
	},
	computed: {
		...mapGetters({
			user: 'user/user',
			specialist: 'specialist/specialist'
		}),
		hasEnoughBalance() {
			if(this.user.balance < this.specialist.minute_price*10) {
				this.buttons = [
					{ event: "topup", text: "Adaugă credite", style: "gradient" },
					{ event: "leave", text: "Părăsește coada" }
				];
				return false;
			}
			
			this.buttons = [
				{ event: "topup", text: "Adaugă credite", style: "gradient" }, //Added by ~RJ | 20.09.21 | Can be removed after offering In-Meeting Topups
				{ event: "leave", text: "Părăsește coada" }
			];
			return true;
		}
	},
	mounted() {
		//Before anything, make sure anytimeMeetingInvite.invite is null (avoid random room generations for expired invites - bug preventing)
		//this.$store.state.specialist.modals.anytimeMeetingInvite.invite = null;

		if(this.hasEnoughBalance){
			//I.Create queue channel string {{specialistId_specialistFullName_queue}}
			this.queueChannel = this.specialist.id + '_' + (this.specialist.full_name).replace(/\s/g, '','') + '_queue';

			//II.Subscribe to queue channel for incoming data
			this.sockets.subscribe(this.queueChannel, data => {
				switch (data.event){
					// case 'join': //This doesn't get sent anymore, now you directly get a response at join
					// 	this.positionsCount = data.user_count;
					// 	this.myPosition = data.position;
					// 	this.orderNumber = data.order_number;
					// 	this.messages = data.messages;
					// 	break;
					case 'update':
						this.positionsCount = data.user_count;
						this.myPosition = data.position;
						break;
					case 'announcement':
						this.messages.push(data.message);
						this.scrollTopMessages();
						if(this.currentPage == 0) this.newMessage = true;
						
						let audio = document.getElementById('anytime-new-announcement');
						audio.play();
						//Todo: push alert
						break;
					case 'invite':
						this.joinAnytimeMeetingInvite(data.invite);
						break;
					case 'unavailable':
						//Todo: trigger modal unavailable
						location.reload();
						break;
				}

			});

			//III.Emit on anytime_queue_join in order to get an orderNumber
			let eventData = {
				queue_channel: this.queueChannel,
				client_id: this.user.id,
				client_name: this.user.full_name,
			}

			this.$socket.emit('anytime_queue_join', eventData, (response) => {
				this.positionsCount = response.user_count;
				this.myPosition = response.position;
				this.orderNumber = response.order_number;
				this.messages = response.messages;
				console.log(response);
			}); //Update client info after getting back the response

			//Messages refresh interval
			//Refresh chat every minute
			setInterval(()=>{this.refreshChat()}, 60000);
		}

	},
	destroyed() {
		//I.Emit on anytime_queue_leave in order to leave the queue
		let eventData = {
			queue_channel: this.queueChannel,
			client_id: this.user.id,
		}
		this.$socket.emit('anytime_queue_leave', eventData);

		//II.Unsubscribe from queueChannel
		this.sockets.unsubscribe(this.queueChannel);

	},
	methods: {
		refreshChat(){
			let messagesCopy = [...this.messages];
			this.messages = [];
			this.messages = messagesCopy;
		},
		prevPage() {
			if (this.currentPage === 0) {
				this.scrollTopMessages();
				this.currentPage = 1;
			} else
				this.currentPage = 0;
		},
		nextPage() {
			if (this.currentPage === 0) {
				this.currentPage = 1;
				this.scrollTopMessages();
				this.newMessage = false;
			} else
				this.currentPage = 0;
		},
		scrollTopMessages() {
			setTimeout(() => {
				this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
			}, 100);
		},
		closeModal() {
			this.currentPage = 0;
			this.$store.state.specialist.modals.anytimeMeeting = false;
		},
		joinAnytimeMeetingInvite(invite) {
			this.$store.state.specialist.modals.anytimeMeeting = false;
			this.$store.state.specialist.modals.anytimeMeetingInvite.invite = invite;
			this.$store.state.specialist.modals.anytimeMeetingInvite.active = true;
		}
	}
}
</script>

<style lang="scss" scoped>
.queue {
	padding: 25px 0;
	position: relative;
	
	&__title {
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 20px;
		line-height: 20px;
		color: #373435;
	}
	
	&__info {
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 20px;
		text-align: center;
		width: 100%;
		margin: 0;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		
		&--warning {
			color: $color-conis;
			margin: 0 5px;
		}
	}
	
	&__divider {
		height: 1px;
		margin: 15px 0;
		background: rgba(55, 52, 53, 0.25);
	}
	
	&__details {
		height: 200px;
		overflow-y: scroll;
		padding: 2px;
		@include media-breakpoint-down(sm) {
            height: 280px;
        }
	}
	
	&__details-list {
		display: flex;
		flex-direction: column;
		// gap: 22px; Does not work for Safari 
		width: 100%;
	}
	
	&__description {
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 20px;
		display: flex;
		align-items: center;
		text-align: justify;
		color: #373435;
		margin-top: 25px;
	}
	
	&__messages {
		height: 200px;
		overflow-y: scroll;
		padding: 2px;
		@include media-breakpoint-down(sm) {
            height: 280px;
        }
	}
}

.list-item {
	display: flex;
	flex-direction: row;
	margin: 6px 0;
	
	&__icon {
		font-size: 22px;
		width: 35px;
		height: 20px;
	}
	
	&__text {
		font-family: 'DIN Pro', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 20px;
		color: #373435;
		display: flex;
		
		&--primary {
			color: $color-primary;
			margin: 0 5px;
		}
		
		&--warning {
			color: $color-conis;
			margin: 0 5px;
		}
	}
}

.message {
	border: 1px solid $color-light-gray;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
	padding: 15px;
		
    &__meta {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    &__name {
        opacity: 0.8;
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
    }

    &__datetime {
        color: $color-primary;
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
    }

    &__text {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        opacity: 0.7;
    }
}


.navigation {
	margin-top: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	
	&__arrow {
		padding: 2px 12px;
		background-color: $color-primary;
		color: $color-card;
		cursor: pointer;
		font-size: 21px;
	}

	&__bullets {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 20px;
	}

	&__bullet {
		height: 10px;
		width: 10px;
		background-color: $color-light-gray;
		border-radius: 100%;

		&:not(:last-child) {
			margin-right: 10px;
		}

		&--active {
			background-color: $color-secondary;
		}

		@keyframes alert {
			0% {background-color: $color-secondary;}
			50% {background-color: $color-primary;}
			100% {background-color: $color-secondary;}
		}

		&--alert{
			animation: alert 3s infinite;
		}
	}
}
</style>